import { Section, ChromeHeading, Card, GoldText } from "../funnel";

const VIDEOS = [
  ["bouncecity", "testimonial-bouncecity", "Client · business owner"],
  ["client", "testimonial-client", "Client · in their own words"],
  ["newclient", "testimonial-newclient", "New client · on our team & service"],
  ["circle", "circle-bw-video", "From Jay's circle · what he's learned"],
];

export const Testimonials = () => (
  <Section data-testid="testimonials-section">
    <ChromeHeading className="text-4xl sm:text-5xl lg:text-6xl" data-testid="testimonials-headline">Hear it from our clients <GoldText>and circle</GoldText></ChromeHeading>
    <div className="mx-auto mt-12 flex max-w-md flex-wrap justify-center gap-8 md:max-w-3xl md:gap-6" data-testid="testimonials-grid">
      {VIDEOS.map(([slug, file, label]) => (
        <figure key={slug} className="w-full md:w-[calc(50%-12px)]" data-testid={`testimonial-${slug}`}>
          <video src={`/assets/${file}.mp4`} poster={`/assets/${file}-poster.jpg`} controls playsInline preload="metadata" className="block aspect-[9/12] w-full rounded-xl border border-[var(--gold)] bg-black object-cover shadow-[0_0_40px_-10px_rgba(232,184,74,0.45)]" aria-label={label} data-testid={`testimonial-${slug}-video`} />
          <figcaption className="font-mono-plex mt-4 text-[12px] tracking-[0.06em] text-[#cfc6b3]">{label}</figcaption>
        </figure>
      ))}
    </div>
    <Card className="mx-auto mt-14 max-w-3xl px-7 py-10 sm:px-12 sm:py-12" data-testid="julie-quote-card">
      <span className="font-serif-it gold-text block text-8xl leading-[0.6]" aria-hidden="true">“</span>
      <blockquote className="font-serif-it mt-4 text-[22px] leading-snug text-[#f4efe4] sm:text-[26px]">
        J11 is by far the best credit repair company I have worked with. Their response time is quick and they address every concern with professionalism and care. … I started seeing progress within a week and received consistent updates throughout the process.
      </blockquote>
      <p className="mt-6 text-[15px] font-semibold text-[var(--gold)]">— Julie C., J11 client</p>
    </Card>
    <p className="mx-auto mt-6 max-w-3xl text-[12px] text-[#8a857b]">Individual client experiences. Results vary and are not typical or guaranteed.</p>
  </Section>
);
